﻿import {UIBase} from "../Tools/Base/UIBase";
import {GameManager} from "../../Game/GameManager";
import {NUtils} from "../../Utils/NUtils";
import {UISprite} from "../Tools/Base/UISprite";
import {UIText} from "../Tools/Base/UIText";
import {Core} from "../../Base/Core";

class TapChallengeProgressBar extends UISprite {
    constructor() {
        super();

        this._progress = 0;
        this._time = 0;
        this._padding = 2;

        this.anchor.set(0);
        this.back = this.addChild(new UISprite("particles/rect"));
        this.back.anchor.set(0);
        this.back.tint = 0x000000;

        this.progressBar = this.addChild(new UISprite("particles/rect"));
        this.progressBar.anchor.set(0);
        this.progressBar.tint = 0xFFFF00;

        this.timeBar = this.addChild(new UISprite("particles/rect"));
        this.timeBar.anchor.set(0);
        this.timeBar.tint = 0xFF0000;

        this._updateProgress();
    }

    get progress() {
        return this._progress;
    }

    set progress(val) {
        this._progress = Math.max(0, Math.min(1, parseFloat(val) || 0));
        this._updateProgress();
    }

    get time() {
        return this._time;
    }

    set time(val) {
        this._time = Math.max(0, Math.min(1, parseFloat(val) || 0));
        this._updateProgress();
    }

    _updateProgress() {
        let w = this.back.width - this._padding * 2;
        this.progressBar.width = w * this._progress;
        this.timeBar.width = w * this._time;
    }

    fitLayout(rect) {
        this._padding = rect.height * 0.1;

        this.position.copyFrom(rect);
        this.back.width = rect.width;
        this.back.height = rect.height;

        let h = rect.height - this._padding * 2;
        this.progressBar.position.set(this._padding, this._padding);
        this.progressBar.height = h * 0.7;

        this.timeBar.position.set(this._padding, this._padding + this.progressBar.height);
        this.timeBar.height = h - this.progressBar.height;

        this._updateProgress();
    }
}

export class UITapChallenge extends UIBase {

    Awake() {
        super.Awake();
        this._scoreField = this.addChild(new UIText(""));
        this._timerField = this.addChild(new UIText("", {fitTextTemplate: "00h 00m 00s"}));
        this._progressBar = this.addChild(new TapChallengeProgressBar());
        this._tapChallengeMode = null; // TapChallengeMode
    }

    Init() {
        super.Init();
        this.SetActive(false);
        this.UpdateScore = this.UpdateScore.bind(this);
        this.HandleChallengeFinish = this.HandleChallengeFinish.bind(this);
        this.HandleChallengeActivation = this.HandleChallengeActivation.bind(this);
        this.HandleChallengeStart = this.HandleChallengeStart.bind(this);
    }

    fitLayout(viewport = Core.app.viewport) {

        let progressRect = new PIXI.Rectangle(
            viewport.width * 0.1,
            viewport.height * 0.1,
            viewport.width * 0.8,
            viewport.height * 0.05,
        );
        this._progressBar.fitLayout(progressRect);

        this._scoreField.anchor.set(0.5, 1);
        this._scoreField.position.set(viewport.width * 0.5, progressRect.top);

        this._timerField.anchor.set(0.5, 0);
        this._timerField.position.set(viewport.width * 0.5, progressRect.bottom);
    }

    UpdateScore(newValue) {
        this._scoreField.text = NUtils.FormatMoney(newValue);
        this._progressBar.progress = this._tapChallengeMode.GetScoreProgress();
    }

    // TapChallengeResult results
    Show(results) {
        super.Show();
        Core.WaitBefore(0.5, () => Core.VFX.hideEffect("merge-progress"));
        if (!this._tapChallengeMode) {
            this._tapChallengeMode = GameManager.TapChallengeMode;
            this._tapChallengeMode.on("ScoreUpdated", this.UpdateScore);
            this._tapChallengeMode.on("Finished", this.HandleChallengeFinish);
            this._tapChallengeMode.on("Activated", this.HandleChallengeActivation);
            this._tapChallengeMode.on("Started", this.HandleChallengeStart);
        }
        this._tapChallengeMode.ActivateChallenge();
        if (results) {
            this._tapChallengeMode.StartChallenge(results, true);
            console.log("RESTART", results, this._tapChallengeMode);
        } else {
            this._tapChallengeMode.StartChallenge(Core.Player.TapChallengeSave);
            this._scoreField.text = NUtils.FormatMoney(this._tapChallengeMode.CurrentScore);
            this._timerField.SetActive(true);
            this._progressBar.SetActive(true);
            Core.VFX.tapChallengeStartBanner();
        }
        this.fitLayout();
    }

    Hide() {
        super.Hide();
    }

    HandleChallengeStart() {
        Core.Player.TapChallengeSave.ChallengeStart();
    }

    HandleChallengeActivation(obj) {
        //throw new NotImplementedException();
    }

    HandleChallengeFinish(result) {
        this.Hide();
        this._tapChallengeMode.DisableChallenge();
        console.log("TAP CHALLENGE FINISHED", result);
        if (result.IsWin) {
            if (!result.IsReplay) Core.Player.TapChallengeSave.ChallengeWin();
            Core.UI.tapChallengeVictory.Show(Core.GameData.TapChallenge.reward);
        } else {
            if (!result.IsReplay) Core.Player.TapChallengeSave.ChallengeLost();
            Core.UI.tapChallengeLost.Show(result);
        }
    }

    Update() {
        this.UpdateTimer();
    }

    UpdateTimer() {
        let timeLeft = this._tapChallengeMode.TimeRemains; // Core.Time.serverTime;  //endDateTime - Core.Time.serverTime;
        this._timerField.text = NUtils.FormatSecondsToTime(timeLeft);
        this._progressBar.time = 1 - this._tapChallengeMode.GetTimeProgress();
    }

    RunTapParticles(position) {
        Core.VFX.tapChallengeTap(position.x, position.y);
    }
}
